import { Link } from "react-router-dom";

// Shown on a shortlisted course an admin has confirmed is no longer offered.
export function NotOfferedNotice({ info, testId }) {
  const alts = info?.alternatives || [];
  const sameUni = alts[0]?.where === "same_university";
  return (
    <div role="status" data-testid={testId} className="mt-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900">
      <p><strong className="font-semibold">No longer offered.</strong> The university doesn't list this course any more. It stays on your list until you remove it.</p>
      {alts.length > 0 ? (
        <p className="mt-1">
          {sameUni ? "Similar courses at the same university: " : "Similar courses elsewhere: "}
          {alts.map((a, i) => (
            <span key={a.degree_id}>
              {i > 0 && " · "}
              <Link to={`/degree/${a.degree_id}`} className="underline hover:text-amber-950" data-testid={`${testId}-alt-${a.degree_id}`}>
                {a.name}{!sameUni && a.university_name ? ` (${a.university_name})` : ""}
              </Link>
            </span>
          ))}
        </p>
      ) : (
        <p className="mt-1">We couldn't find a close alternative yet.</p>
      )}
    </div>
  );
}
